export const actionTypes = {
    SET_LEAVE_APPROVALS: "SET_LEAVE_APPROVALS",
    SET_PENDING_APPROVALS: "SET_PENDING_APPROVALS",
    SET_APPROVAL_HISTORY: "SET_APPROVAL_HISTORY",
    SET_APPROVAL_STATS: "SET_APPROVAL_STATS",
    SET_LOADING: "SET_LOADING",
    SET_ERROR: "SET_ERROR",
    CLEAR_APPROVALS: "CLEAR_APPROVALS",
    UPDATE_APPROVAL_STATUS: "UPDATE_APPROVAL_STATUS",
    ADD_APPROVAL: "ADD_APPROVAL",
    REMOVE_APPROVAL: "REMOVE_APPROVAL",
    SET_LEAVE_REQUEST_CARDS: "SET_LEAVE_REQUEST_CARDS",
    APPEND_LEAVE_REQUEST_CARDS: "APPEND_LEAVE_REQUEST_CARDS",
    SET_PAGINATION_INFO: "SET_PAGINATION_INFO",
    SET_LOADING_MORE: "SET_LOADING_MORE",
    // Self-requested leaves actions
    SET_SELF_LEAVES_STATS: "SET_SELF_LEAVES_STATS",
    SET_SELF_LEAVES: "SET_SELF_LEAVES",
    APPEND_SELF_LEAVES: "APPEND_SELF_LEAVES",
    SET_SELF_LEAVES_LOADING: "SET_SELF_LEAVES_LOADING",
    SET_SELF_LEAVES_LOADING_MORE: "SET_SELF_LEAVES_LOADING_MORE",
}; 